module.exports = __webpack_public_path__ + "img/4.c0ca1aa9.svg";